/* eslint-disable jsx-a11y/anchor-is-valid */

import {useEffect, useState} from 'react'
import axios from 'axios'
import {useParams} from 'react-router-dom'
import Swal from 'sweetalert2'
import firebase from '../../../../firebase/FirebaseConfig'
import apiConnect from '../../../../api/apiConnect'
import {useNavigate} from 'react-router-dom'
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter'
import {materialDark} from 'react-syntax-highlighter/dist/esm/styles/prism'
import Select from 'react-select'

const VBoxShowScript = () => {
  const db = firebase.firestore()
  const deviceId = useParams().deviceId
  const navigate = useNavigate()
  const [deviceData, setDeviceData] = useState([])
  const [listParameter, setListParameter] = useState([])
  const [luaScriptVersion, setLuaScriptVersion] = useState('version1.0.0')

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/devices/by-device-id/${deviceId}`)

        // Check Device ID
        if (response?.data?.status == 'error' && response?.data?.text == 'No such document!') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Device not found!',
          }).then(() => {
            navigate(`/device/${deviceId}`)
          })
        }

        setDeviceData(response.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      let listParameter = []
      await db
        .collection('parameters')
        .where('deviceId', '==', deviceId)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            listParameter.push({parameterId: doc.id, ...doc.data(), mainType: 'parameter'})
          })
        })
        .catch((error) => {
          console.log('Error getting documents: ', error)
        })

      await db
        .collection('statusParameters')
        .where('deviceId', '==', deviceId)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            listParameter.push({parameterId: doc.id, ...doc.data(), mainType: 'statusParameter'})
          })
        })
        .catch((error) => {
          console.log('Error getting documents: ', error)
        })

      await db
        .collection('settingParameters')
        .where('deviceId', '==', deviceId)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            listParameter.push({parameterId: doc.id, ...doc.data(), mainType: 'settingParameter'})
          })
        })
        .catch((error) => {
          console.log('Error getting documents: ', error)
        })

      setListParameter(listParameter)
    }
    fetchData()
  }, [])

  const parIdList = listParameter
    .filter((item) => item.mainType === 'parameter')
    .map((item) => `"${item.parameterId}"`)
    .join(',')

  const parAdrList = listParameter
    .filter((item) => item.mainType === 'parameter')
    .map((item) => `"${item.parameterAddress}"`)
    .join(',')

  const parTypList = listParameter
    .filter((item) => item.mainType === 'parameter')
    .map((item) => `${item.parameterType}`)
    .join(',')

  const parColList = listParameter
    .filter((item) => item.mainType === 'parameter')
    .map((item) => `${item.collectionType}`)
    .join(',')

  const parOprList = listParameter
    .filter((item) => item.mainType === 'parameter')
    .map((item) => `${item.operationType}`)
    .join(',')

  const parOprValList = listParameter
    .filter((item) => item.mainType === 'parameter')
    .map((item) => `${item.operationValue}`)
    .join(',')

  const setIdList = listParameter
    .filter((item) => item.mainType === 'settingParameter')
    .map((item) => `"${item.parameterId}"`)
    .join(',')

  const setAdrList = listParameter
    .filter((item) => item.mainType === 'settingParameter')
    .map((item) => `"${item.parameterAddress}"`)
    .join(',')

  const setTypList = listParameter
    .filter((item) => item.mainType === 'settingParameter')
    .map((item) => `${item.parameterType}`)
    .join(',')

  const staIdList = listParameter
    .filter((item) => item.mainType === 'statusParameter')
    .map((item) => `"${item.parameterId}"`)
    .join(',')

  const staAdrList = listParameter
    .filter((item) => item.mainType === 'statusParameter')
    .map((item) => `"${item.parameterAddress}"`)
    .join(',')

  const staTypList = listParameter
    .filter((item) => item.mainType === 'statusParameter')
    .map((item) => `${item.parameterType}`)
    .join(',')

  const luaScriptVersion100 = `
-- M1Conn_revD06_250410_Aunc_01
-- ## Device Config
local CLB_DEV_NAME = "${deviceData?.gateway_id}"
local DEV_ID = "${deviceData?.device_id}"

local RSA_PRIVATE = [[${deviceData?.privateKey}]]

-- ## Start :: Header --
local json = require("json")
local D = {BT = 0,WR = 1,SH = 2,IN = 3,DW = 4,FT = 5,DB = 6,FT2 = 7,DB7 = 8,CA = 9,ST = 10,IN2 = 11}
local C = {LT = 0,AV = 1,MX = 2,MN = 3}
local O = {N = 0,A = 1,S = 2,M = 3,D = 4} -- no, +, -, *, /
local CMD_BUF = {MAX_CMD = 10,MAX_LEN = 200,MIN_LEN = 10}
local STA = {MAX_PAR = 8,MAX_ROW = 16,SZ_PAR = 800,SZ_ROW = 50,SZ_ID = 10,LEN_ID = 20,LEN_MSG = 50,OFS_CID = 0,OFS_ISN = 20,OFS_MSK = 21,OFS_CDE = 22,OFS_MSG = 23,EMP_MSG = "00000000000000000000"}
local B_S = {MAX_BUP = 240,SZ_SLT = 140,SZ_MSG = 260,OFS_TMS = 0,OFS_SZ_MSG = 2,OFS_MSG = 5,B_TS = 1729242798}
local B_E = {MAX_BUP = 120,SZ_SLT = 1200,SZ_MSG = 2350,OFS_TMS = 0,OFS_SZ_MSG = 2,OFS_MSG = 5,B_TS = 1729242798}
local gLstTm, gbPubInv, gbLstPubTm = 0, 0, 0
local DEV_SET_ADR, PRINT_LOG_SET_ADR, RESTART_F_ADR, PUB_TS_ADR = "@W_HDW900", "@W_HDW904", "@W_HDW908", "@W_HDW912"
local COL_VAL_BADR, COL_CNT_BADR, CMD_CNT_ADR = "@W_HDW1000", "@W_HDW1400", "@W_HDW3000"
local CMD_LEN_BADR, CMD_BADR = "@W_HDW3002", "@W_HDW3040"
local PUB_INT_ADR, PRM_STA_ADR, PRM_REM_ADR = "@W_HAW904", "@W_HAW910", "@W_HAW914"
local LIM_HVAL_BADR, LIM_LVAL_BADR, LIM_LST_VAL_BADR, LIM_LST_EVN_BADR = "@W_HAW1000", "@W_HAW1100", "@W_HAW1200",
"@W_HAW1300"
local ROC_HVAL_BADR, ROC_LVAL_BADR, ROC_LST_EVN_BADR = "@W_HAW1400", "@W_HAW1500", "@W_HAW1600"
local LST_PUB_VAL_BADR = "@W_HAW1700"
local STA_COD_BADR, STA_LST_BADR = "@W_HAW6000", "@W_HAW19000"
local B_EP_BADR, B_SP_BADR = "@W_HAW20000", "@W_HAW165000"
-- ## Start :: Device Config --
local MQTT_URL = "ssl://asia-east1-mqtt.clearblade.com:8883"

local MQTT_CLIENT_ID =
    "projects/dygistechplatform/locations/asia-east1/registries/mercury-prod-gateway-registry-01/devices/" .. CLB_DEV_NAME
local SUB_CONF_TP = "/devices/" .. CLB_DEV_NAME .. "/config"
local SUB_CMD_TP = "/devices/" .. CLB_DEV_NAME .. "/commands/#"
local PUB_NOR_TP = "/devices/" .. CLB_DEV_NAME .. "/events"
local PUB_ALM_TP = "/devices/" .. CLB_DEV_NAME .. "/events/alarm"
local PUB_STA_TP = "/devices/" .. CLB_DEV_NAME .. "/events/status_parameter_alarm"
local ROOT_CERT = [[-----BEGIN CERTIFICATE-----
MIIDrzCCApegAwIBAgIQCDvgVpBCRrGhdWrJWZHHSjANBgkqhkiG9w0BAQUFADBh
MQswCQYDVQQGEwJVUzEVMBMGA1UEChMMRGlnaUNlcnQgSW5jMRkwFwYDVQQLExB3
d3cuZGlnaWNlcnQuY29tMSAwHgYDVQQDExdEaWdpQ2VydCBHbG9iYWwgUm9vdCBD
QTAeFw0wNjExMTAwMDAwMDBaFw0zMTExMTAwMDAwMDBaMGExCzAJBgNVBAYTAlVT
MRUwEwYDVQQKEwxEaWdpQ2VydCBJbmMxGTAXBgNVBAsTEHd3dy5kaWdpY2VydC5j
b20xIDAeBgNVBAMTF0RpZ2lDZXJ0IEdsb2JhbCBSb290IENBMIIBIjANBgkqhkiG
9w0BAQEFAAOCAQ8AMIIBCgKCAQEA4jvhEXLeqKTTo1eqUKKPC3eQyaKl7hLOllsB
CSDMAZOnTjC3U/dDxGkAV53ijSLdhwZAAIEJzs4bg7/fzTtxRuLWZscFs3YnFo97
nh6Vfe63SKMI2tavegw5BmV/Sl0fvBf4q77uKNd0f3p4mVmFaG5cIzJLv07A6Fpt
43C/dxC//AH2hdmoRBBYMql1GNXRor5H4idq9Joz+EkIYIvUX7Q6hL+hqkpMfT7P
T19sdl6gSzeRntwi5m3OFBqOasv+zbMUZBfHWymeMr/y7vrTC0LUq7dBMtoM1O/4
gdW7jVg/tRvoSSiicNoxBN33shbyTApOB6jtSj1etX+jkMOvJwIDAQABo2MwYTAO
BgNVHQ8BAf8EBAMCAYYwDwYDVR0TAQH/BAUwAwEB/zAdBgNVHQ4EFgQUA95QNVbR
TLtm8KPiGxvDl7I90VUwHwYDVR0jBBgwFoAUA95QNVbRTLtm8KPiGxvDl7I90VUw
DQYJKoZIhvcNAQEFBQADggEBAMucN6pIExIK+t1EnE9SsPTfrgT1eXkIoyQY/Esr
hMAtudXH/vTBH1jLuG2cenTnmCmrEbXjcKChzUyImZOMkXDiqw8cvpOp/2PV5Adg
06O/nVsJ8dWO41P0jmP6P6fbtGbfYmbW0W5BjfIttep3Sp+dWOIrWcBAI+0tKIJF
PnlUkiaY4IBIqDfv8NZ5YBberOgOzW6sRBc4L0na4UU+Krk2U886UAb3LujEV0ls
YSEY1QSteDwsOoBrp+uvFRTp2InBuThs4pFsiv9kuXclVzDAGySj4dzp30d8tbQk
CAUw7C29C79Fv1C5qfPrmAESrciIxpg0X40KPMbp1ZWVbd4=
-----END CERTIFICATE-----]]
-- ## Parameter Config

local PAR_ID = {${parIdList}} -- Parameter
local PAR_ADR = {${parAdrList}}
local PAR_TYP = {${parTypList}}
local PAR_COL = {${parColList}}
local PAR_OPR = {${parOprList}}
local PAR_OPR_VAL = {${parOprValList}}

local SET_ID = {${setIdList}} -- Setting Parameter
local SET_ADR = {${setAdrList}}
local SET_TYP = {${setTypList}}
local STA_ID = {${staIdList}} -- Status Parameter <= 8 params
local STA_ADR = {${staAdrList}}
local STA_TYP = {${staTypList}}

function Malin1Connect.main()
    local limParIDs, limVals, limEvns, limHs, limLs = {}, {}, {}, {}, {}
    local rocParIDs, rocAlmVals, rocEvns, rocHs, rocLs = {}, {}, {}, {}, {}
    Conf()
    if #PAR_ID <= 40 and #SET_ID <= 40 and #STA_ID <= 8 and #PAR_ID + #SET_ID + #STA_ID <= 40 then
        if #PAR_ADR > 0 then
            PLog(".", 3)
            for i = 1, #PAR_ADR do
                local CV = GTGDat(i)
                local clV = GAd(D.DB, COL_VAL_BADR, i)
                local ClN = GAd(D.WR, COL_CNT_BADR, i)
                local lstV = GAd(D.FT, LIM_LST_VAL_BADR, i)
                clV = (clV == nil) and 0 / 0 or clV
                ClN = (ClN == ClN and ClN ~= nil) and ClN or 0
                lstV = (lstV == nil) and 0 / 0 or lstV
                if ClN == 0 or clV ~= clV then
                    SAd(D.DB, CV, COL_VAL_BADR, i)
                    SAd(D.WR, 1, COL_CNT_BADR, i)
                else
                    if CV == CV then
                        if (PAR_COL[i] == C.AV) then
                            SAd(D.DB, clV + CV, COL_VAL_BADR, i)
                            SAd(D.WR, ClN + 1, COL_CNT_BADR, i)
                        elseif (PAR_COL[i] == C.MX) then
                            if CV > clV then
                                SAd(D.DB, CV, COL_VAL_BADR, i)
                                SAd(D.WR, ClN + 1, COL_CNT_BADR, i)
                            end
                        elseif (PAR_COL[i] == C.MN) then
                            if CV < clV then
                                SAd(D.DB, CV, COL_VAL_BADR, i)
                                SAd(D.WR, ClN + 1, COL_CNT_BADR, i)
                            end
                        else -- CT.LST
                            SAd(D.DB, CV, COL_VAL_BADR, i)
                            SAd(D.WR, ClN + 1, COL_CNT_BADR, i)
                        end
                    end
                end
                SAd(D.FT, CV, LIM_LST_VAL_BADR, i)
                if (i <= #PAR_ID) and (CV == CV) and (CV ~= nil) and (lstV == lstV) and (lstV ~= nil) then
                    local limLstEvn = GAd(D.CA, LIM_LST_EVN_BADR, i)
                    local limEvn, limHVal, limLVal = ChkLim(i, CV)
                    if limEvn ~= "N" and limEvn ~= limLstEvn then
                        table.insert(limParIDs, PAR_ID[i])
                        table.insert(limEvns, limEvn)
                        table.insert(limVals, tostring(toH32(CV)))
                        table.insert(limHs, tostring(toH32(limHVal)))
                        table.insert(limLs, tostring(toH32(limLVal)))
                    end
                    SAd(D.CA, limEvn, LIM_LST_EVN_BADR, i)
                    local rocLstEvn = GAd(D.CA, ROC_LST_EVN_BADR, i)
                    local rocVal, rocEvn, rocHVal, rocLVal = ChkRocLim(i, CV, lstV)
                    if rocEvn ~= "N" and rocEvn ~= rocLstEvn then
                        table.insert(rocParIDs, PAR_ID[i])
                        table.insert(rocEvns, rocEvn)
                        table.insert(rocAlmVals, tostring(toH32(rocVal)))
                        table.insert(rocHs, tostring(toH32(rocHVal)))
                        table.insert(rocLs, tostring(toH32(rocLVal)))
                    end
                    SAd(D.CA, rocEvn, ROC_LST_EVN_BADR, i)
                end
            end
        end
        if g_mq then
            local curTime = os.time()
            local fPub = false
            if g_mq:isconnected() ~= true then
                if (os.time() - gLstTm) > 20 then
                    gLstTm = os.time()
                    MqttConn()
                    SAd(D.WR, 0, CMD_CNT_ADR)
                    for k = 1, CMD_BUF.MAX_CMD do
                        SAd(D.WR, 0, CMD_LEN_BADR, k)
                    end
                end
            end
            if gbPubInv >= 1 then
                if GAd(D.WR, RESTART_F_ADR) == 1 then
                    if ((curTime - gbLstPubTm) >= (gbPubInv * 60)) then
                        LpPub(curTime)
                        fPub = true
                    end
                else
                    local minutes = tonumber(os.date("%M")) + 1
                    local modPubInterval = (gbPubInv % 60 == 0) and 60 or gbPubInv % 60
                    if (minutes % modPubInterval) == 0 then
                        local sec = tonumber(os.date("%S"))
                        if sec >= 48 then
                            FtPubDelay(60 - sec)
                            curTime = os.time()
                            LpPub(curTime)
                            fPub = true
                        end
                    end
                end
            end
            ChkStaPar(true)
            if g_mq:isconnected() then
                if fPub == false then
                    if #limParIDs > 0 then
                        PubAlmLim(limParIDs, limEvns, limVals, limHs, limLs, "VAL_EVENT")
                    end
                    if #rocParIDs > 0 then
                        PubAlmLim(rocParIDs, rocEvns, rocAlmVals, rocHs, rocLs, "ROC_EVENT")
                    end
                    RePub(PUB_NOR_TP, B_EP_BADR, B_E)
                    RePub(PUB_STA_TP, B_SP_BADR, B_S)
                end
                ActCmd()
            end
        else
            MqttInit()
        end
    else
        PLog("ERR:Parameter list...", 1)
    end
end
function SStrChk(str, bAdr, loc)
    local chunkSize, startIndex, length = 200, 1, #str
    if length < B_E.SZ_MSG then
        while startIndex <= length do
            local endIndex = math.min(startIndex + chunkSize - 1, length)
            local chunk = str:sub(startIndex, endIndex)
            local memoryOffset = math.floor((startIndex - 1) / 2)
            local rdAdr = addr_newnoaddr(bAdr, loc + memoryOffset)
            addr_setstring(rdAdr, chunk)
            startIndex = endIndex + 1
        end
    end
end
function GStrChk(len, bAdr, loc)
    local chunkSize, startIndex = 200, 1
    local result = ""
    while startIndex <= len do
        local endIndex = math.min(startIndex + chunkSize - 1, len)
        local memoryOffset = math.floor((startIndex - 1) / 2)
        local rdAdr = addr_newnoaddr(bAdr, loc + memoryOffset)
        local chunk = addr_getstring(rdAdr, endIndex - startIndex + 1)
        if not chunk then
            break
        end
        result = result .. chunk
        startIndex = endIndex + 1
    end
    return result
end
function LpPub(pbT)
    PubEvn(pbT)
    ChkStaPar(false, pbT)
    SAd(D.DW, pbT, PUB_TS_ADR)
    for j = 1, #PAR_ADR do
        SAd(D.DB, 0, COL_VAL_BADR, j)
        SAd(D.WR, 0, COL_CNT_BADR, j)
    end
    if GAd(D.WR, RESTART_F_ADR) ~= 1 then
        SAd(D.WR, 1, RESTART_F_ADR)
    end
end
function FtPubDelay(sec)
    if sec > 1 and sec <= 14 then
        sec = sec - 1
        local start = os.clock()
        while os.clock() - start < sec do
        end
    end
end
function GDatSz(dtp)
    local sizes = {[D.BT] = 1,[D.WR] = 1,[D.SH] = 1,[D.IN] = 2,[D.IN2] = 2,[D.DW] = 2,[D.FT] = 2,[D.FT2] = 2,[D.DB] = 4,[D.DB7] = 4,[D.CA] = 1}
    return sizes[dtp] or 1
end
function GTGDat(Ix)
    local tgD = GAd(PAR_TYP[Ix], PAR_ADR[Ix])
    local op = PAR_OPR[Ix]
    local opV = PAR_OPR_VAL[Ix]
    op = (op == op and op ~= nil) and op or 0
    opV = (opV == opV and opV ~= nil) and opV or 0
    if tgD == nil or tgD ~= tgD then
        return 0 / 0
    elseif opV == 0 then
        return tgD
    else
        if op == O.A then
            return tgD + opV
        elseif op == O.S then
            return tgD - opV
        elseif op == O.M then
            return tgD * opV
        elseif op == O.D then
            return tgD / opV
        else
            return tgD
        end
    end
end
function GStaL(StaIx, RowIx, Offset)
    return ((RowIx - 1) * STA.SZ_ROW) + ((StaIx - 1) * STA.SZ_PAR) + Offset
end
function GBupL(Ix, Offset, conf)
    return ((Ix - 1) * conf.SZ_SLT) + Offset + 1
end
function SAd(dtp, dat, bAdr, loc, FPg)
    loc = loc or 1
    FPg = FPg or 0
    local wordCnt = (FPg == 1) and 1 or GDatSz(dtp)
    local adr = (loc <= 1) and bAdr or addr_newnoaddr(bAdr, (loc - 1) * wordCnt)
    if dat ~= nil then
        if dtp == D.BT then
            dat = (dat == 0) and 0 or 1
            addr_setbit(adr, dat)
        elseif dtp == D.WR then
            dat = (dat > 0xFFFF) and 0xFFFF or math.tointeger(dat)
            addr_setword(adr, dat)
        elseif dtp == D.SH then
            addr_setshort(adr, dat)
        elseif dtp == D.IN then
            dat = math.tointeger(dat)
            addr_setint(adr, dat)
        elseif dtp == D.IN2 then
            dat = math.tointeger(dat)
            addr_setint(adr, dat, 0, 2)
        elseif dtp == D.DW then
            addr_setdword(adr, dat)
        elseif dtp == D.FT then
            if dat == math.huge or dat > 3.4028235e+38 or dat == -math.huge or dat < -3.4028235e+38 or dat ~= dat then
                addr_setdword(adr, 0x7FC00000)
            else
                addr_setfloat(adr, dat)
            end
        elseif dtp == D.FT2 then
            if dat == math.huge or dat > 3.4028235e+38 or dat == -math.huge or dat < -3.4028235e+38 or dat ~= dat then
                addr_setdword(adr, 0x7FC00000, 0, 2) -- nan
            else
                addr_setfloat(adr, dat, 0, 2)
            end
        elseif dtp == D.DB then
            if dat == math.huge or dat == -math.huge or dat ~= dat then
                addr_sethex64(adr, 0x7FF8000000000000) -- nan
            else
                addr_setdouble(adr, dat)
            end
        elseif dtp == D.DB7 then
            if dat == math.huge or dat == -math.huge or dat ~= dat then
                addr_sethex64(adr, 0x7FF8000000000000, 0, 7) -- nan
            else
                addr_setdouble(adr, dat, 0, 7)
            end
            addr_setdouble(adr, dat, 0, 7)
        elseif dtp == D.CA then
            if type(dat) == "string" and #dat == 1 then
                addr_setword(adr, string.byte(dat))
            else
                addr_setword(adr, string.byte(0))
            end
        else
            addr_setword(adr, dat)
        end
    end
end
function GAd(dtp, bAdr, loc, FPg)
    loc = loc or 1
    FPg = FPg or 0
    local wordCnt = (FPg == 1) and 1 or GDatSz(dtp)
    local adr = (loc <= 1) and bAdr or addr_newnoaddr(bAdr, (loc - 1) * wordCnt)
    if dtp == D.BT then
        return addr_getbit(adr)
    elseif dtp == D.WR then
        return addr_getword(adr)
    elseif dtp == D.SH then
        return addr_getshort(adr)
    elseif dtp == D.IN then
        return addr_getint(adr)
    elseif dtp == D.IN2 then
        return addr_getint(adr,0 ,2)
    elseif dtp == D.DW then
        return addr_getdword(adr)
    elseif dtp == D.FT then
        return addr_getfloat(adr)
    elseif dtp == D.FT2 then
        return addr_getfloat(adr, 0, 2)
    elseif dtp == D.DB then
        return addr_getdouble(adr)
    elseif dtp == D.DB7 then
        return addr_getdouble(adr, 0, 7)
    elseif dtp == D.CA then
        local getChar = addr_getword(adr)
        return (getChar <= 255) and string.char(getChar) or ""
    else
        return addr_getword(adr)
    end
end
function Conf()
    local PrmStatus = GAd(D.WR, PRM_STA_ADR)
    local PrmRem = GAd(D.WR, PRM_REM_ADR)
    gbPubInv = GAd(D.WR, PUB_INT_ADR)
    if ((PrmStatus == 0 or PrmRem <= 0) and (gbPubInv < 10)) or (gbPubInv < 1) then
        gbPubInv = 10
        SAd(D.WR, gbPubInv, PUB_INT_ADR)
    end
    gbLstPubTm = GAd(D.DW, PUB_TS_ADR)
    local dst = GAd(D.WR, DEV_SET_ADR) or 0
    dst = dst % 100
    if dst == 11 then
        for i = 1, B_E.MAX_BUP do
            SAd(D.DW, 0, B_EP_BADR, GBupL(i, B_E.OFS_TMS, B_E), 1)
            SAd(D.WR, 0, B_EP_BADR, GBupL(i, B_E.OFS_SZ_MSG, B_E))
        end
        SAd(D.WRD, 0, DEV_SET_ADR)
        PLog("#parameter backup deleted...", 2)
    elseif dst == 21 then
        for i = 1, B_S.MAX_BUP do
            SAd(D.DW, 0, B_SP_BADR, GBupL(i, B_S.OFS_TMS, B_S), 1)
            SAd(D.WR, 0, B_SP_BADR, GBupL(i, B_S.OFS_SZ_MSG, B_S))
        end
        SAd(D.WR, 0, DEV_SET_ADR)
        PLog("#status alarm backup deleted...", 2)
    elseif dst == 22 then
        for x = 1, #STA_ID do
            for y = 1, STA.MAX_ROW do
                addr_setstring(addr_newnoaddr(STA_COD_BADR, GStaL(x, y, STA.OFS_CID)), STA.EMP_MSG)
            end
        end
        SAd(D.WR, 0, DEV_SET_ADR)
        PLog("#status code deleted...", 2)
    elseif dst == 31 then
        for x = 1, #PAR_ADR do
            SAd(D.FT, math.huge, LIM_HVAL_BADR, x)
            SAd(D.FT, -math.huge, LIM_LVAL_BADR, x)
        end
        SAd(D.WR, 0, DEV_SET_ADR)
        PLog("#Limit H,L Reset...", 2)
    elseif dst == 32 then
        for x = 1, #PAR_ADR do
            SAd(D.FT, math.huge, ROC_HVAL_BADR, x)
            SAd(D.FT, -math.huge, ROC_LVAL_BADR, x)
        end
        SAd(D.WR, 0, DEV_SET_ADR)
        PLog("#ROC Limit Reset...", 2)
    end
end
function MqttInit()
    g_mq, err = mqtt.create(MQTT_URL, MQTT_CLIENT_ID, 1)
    if g_mq then
        g_mq:on("message", MqttMsgCB)
        PLog("mqtt_init, success", 1)
    end
end
function MqttConn()
    local MQTT_CFG = {
        username = "",
        password = ""
    }
    local _jwt = GenJwt()
    MQTT_CFG.password = _jwt
    local MQTT_LWT = {
        topic = PUB_NOR_TP,
        message = "alived"
    }
    local stat, err = g_mq:connect(MQTT_CFG, MQTT_LWT, ROOT_CERT)
    if stat == nil then
        PLog("connect fail", 1)
        PLog("connect err :: " .. err, 1)
        return
    end
    g_mq:subscribe(SUB_CMD_TP, 0)
    g_mq:subscribe(SUB_CONF_TP, 0)
    PLog("connected...", 1)
end
function MqttMsgCB(topic, msg)
    local cmdCnt = GAd(D.WR, CMD_CNT_ADR) or 0
    if msg == "" or msg == nil then
        return
    end
    msg = string.gsub(msg, "[%c]", "")
    if #msg > CMD_BUF.MIN_LEN and cmdCnt < CMD_BUF.MAX_CMD then
        local adr = addr_newnoaddr(CMD_BADR, (cmdCnt) * (CMD_BUF.MAX_LEN))
        addr_setstring(adr, msg)
        SAd(D.WR, cmdCnt + 1, CMD_CNT_ADR)
        SAd(D.WR, #msg, CMD_LEN_BADR, cmdCnt + 1)
    end
end
function ActCmd()
    local cmdCnt = GAd(D.WR, CMD_CNT_ADR) or 0
    local msgLen = GAd(D.WR, CMD_LEN_BADR, cmdCnt) or 0
    local msg, adr = "", ""
    if cmdCnt > 0 and cmdCnt <= CMD_BUF.MAX_CMD then
        msgLen = GAd(D.WR, CMD_LEN_BADR, cmdCnt)
        adr = addr_newnoaddr(CMD_BADR, (cmdCnt - 1) * (CMD_BUF.MAX_LEN))
        msg = addr_getstring(adr, msgLen)
        PLog("#CMD " .. cmdCnt .. " :: " .. msg .. "_[" .. msgLen .. "]", 2)
        local revData = json.decode(msg)
        if type(revData) == 'table' then
            local m1Cmd, m1ParID, m1LimH, m1LimL, m1Val, m1PrmRem, m1SettingVal
            local m1StaParID, m1StaMask, m1StaCode, m1StaCmdId, m1StaMsg, m1StaIsNor
            local m1ValidSta = false
            for k, v in pairs(revData) do
                if k == "cmd" then
                    m1Cmd = v
                elseif k == "value" then
                    if type(v) == "string" then
                        m1Val = (v == "true") and 1 or 0
                    else
                        m1Val = v
                    end
                elseif k == "rem" then
                    m1PrmRem = v and v or 0
                elseif k == "cmd_id" then
                    m1StaCmdId = v and v or ""
                elseif k == "data" and type(v) == 'table' then
                    m1ParID = v.params
                    m1StaParID = v.param
                    m1LimH = v.max and frmH32(v.max) or 0
                    m1LimL = v.min and frmH32(v.min) or 0
                    m1SettingVal = v.values and frmH32(v.values) or 0
                    m1StaMsg = v.msg and v.msg[1] or ""
                    if v.is_normal ~= nil then
                        if type(v.is_normal[1]) == "string" then
                            m1StaIsNor = (v.is_normal[1] == "true") and 1 or 0
                        end
                    end
                    if v.code ~= nil then
                        if #v.code >= 0 then
                            m1StaCode = frmH32(v.code[1])
                            m1ValidSta = true
                        else
                            m1ValidSta = false
                        end
                    end
                    if v.mask ~= nil then
                        if #v.mask >= 0 then
                            m1StaMask = frmH32(v.mask[1])
                            m1ValidSta = true
                        else
                            m1ValidSta = false
                        end
                    end
                end
            end
            if m1Cmd == "set_lim" then
                local parID = findIx(PAR_ID, m1ParID)
                if parID ~= nil then
                    SAd(D.FT, m1LimH, LIM_HVAL_BADR, parID)
                    SAd(D.FT, m1LimL, LIM_LVAL_BADR, parID)
                end
            elseif m1Cmd == "set_roc" then
                local rocParID = findIx(PAR_ID, m1ParID)
                if rocParID ~= nil then
                    SAd(D.FT, m1LimH, ROC_HVAL_BADR, rocParID)
                    SAd(D.FT, m1LimL, ROC_LVAL_BADR, rocParID)
                end
            elseif m1Cmd == "set_interval" then
                SAd(D.WR, m1Val, PUB_INT_ADR)
                gbPubInv = m1Val
            elseif m1Cmd == "set_premium" then
                SAd(D.WR, tonumber(m1Val), PRM_STA_ADR)
                SAd(D.WR, tonumber(m1PrmRem), PRM_REM_ADR)
            elseif m1Cmd == "set_setparam" then
                local staParID = findIx(SET_ID, m1ParID)
                if staParID ~= nil then
                    SAd(SET_TYP[staParID], m1SettingVal, SET_ADR[staParID])
                end
            elseif m1Cmd == "set_sta_mst" then
                local staParIx = findIx(STA_ID, m1StaParID)
                if (staParIx ~= nil) and (staParIx > 0) and (m1StaIsNor ~= nil) and (m1StaMask ~= nil) and
                    (m1StaCode ~= nil) and (m1StaMsg ~= nil) then
                    if staParIx <= STA.MAX_PAR then
                        local staRow, staRowNew = 0, 0
                        local retMsg, adr = "", ""
                        for x = 1, STA.MAX_ROW do
                            adr = addr_newnoaddr(STA_COD_BADR, GStaL(staParIx, x, STA.OFS_CID))
                            retMsg = addr_getstring(adr, STA.LEN_ID)
                            if (retMsg == "" or retMsg == STA.EMP_MSG or retMsg == nil) and staRowNew == 0 then
                                staRowNew = x
                            end
                            if m1StaCmdId == retMsg then
                                staRow = x
                                staRowNew = 0
                                break
                            end
                        end
                        if (staRow > 0 and staRowNew == 0) or (staRow == 0 and staRowNew > 0) then
                            if (staRow == 0 and staRowNew > 0) then
                                adr = addr_newnoaddr(STA_COD_BADR, GStaL(staParIx, staRowNew, STA.OFS_CID))
                                addr_setstring(adr, m1StaCmdId)
                                staRow = staRowNew
                            end
                            SAd(D.WR, m1StaIsNor, STA_COD_BADR, GStaL(staParIx, staRow, STA.OFS_ISN))
                            SAd(D.WR, m1StaMask, STA_COD_BADR, GStaL(staParIx, staRow, STA.OFS_MSK))
                            SAd(D.WR, m1StaCode, STA_COD_BADR, GStaL(staParIx, staRow, STA.OFS_CDE))
                            adr = addr_newnoaddr(STA_COD_BADR, GStaL(staParIx, staRow, STA.OFS_MSG))
                            addr_setstring(adr, m1StaMsg)
                        end
                    end
                end
            elseif m1Cmd == "del_sta_mst" then
                local staParID = findIx(STA_ID, m1StaParID)
                if (staParID ~= nil) and (staParID > 0) then
                    if staParID <= STA.MAX_PAR then
                        local staRow = 0
                        local retMsg, adr = "", ""
                        for x = 1, STA.MAX_ROW do
                            adr = addr_newnoaddr(STA_COD_BADR, GStaL(staParID, x, STA.OFS_CID))
                            retMsg = addr_getstring(adr, STA.LEN_ID)
                            if m1StaCmdId == retMsg then
                                staRow = x
                                break
                            end
                        end
                        if staRow > 0 then
                            adr = addr_newnoaddr(STA_COD_BADR, GStaL(staParID, staRow, STA.OFS_CID))
                            addr_setstring(adr, STA.EMP_MSG)
                        end
                    end
                end
            end
        end
        SAd(D.WR, cmdCnt - 1, CMD_CNT_ADR)
        SAd(D.WR, 0, CMD_LEN_BADR, cmdCnt)
    end
end
function GenJwt()
    local JWTType, payload, head = 0, {}, {}
    local _jwt_en = jwt_encode(head, payload, "dygistechplatform", os.time(), os.time() + 43200, RSA_PRIVATE, JWTType);
    return _jwt_en
end
function PubEvn(pubtime)
    local vals, limEvns, rocVals, rocEvns = {}, {}, {}, {}
    for i = 1, #PAR_ID do
        local pubVal
        local colVal = GAd(D.DB, COL_VAL_BADR, i)
        local cntVal = GAd(D.WR, COL_CNT_BADR, i)
        pubVal = (PAR_COL[i] == C.AV) and (colVal / cntVal) or colVal
        table.insert(vals, tostring(toH32(pubVal)))
        local limEvn, LIM_HVal, LIM_LVal = ChkLim(i, pubVal)
        table.insert(limEvns, limEvn)
        local lstPubVal = GAd(D.FT, LST_PUB_VAL_BADR, i)
        local rocVal, rocEvn, rocHVal, rocLVal = ChkRocLim(i, pubVal, lstPubVal)
        SAd(D.FT, pubVal, LST_PUB_VAL_BADR, i)
        table.insert(rocVals, tostring(toH32(rocVal)))
        table.insert(rocEvns, rocEvn)
    end
    local pubData = {{
        data = {
            events = limEvns,
            params = PAR_ID,
            roc_events = rocEvns,
            roc_values = rocVals,
            values = vals
        },
        device_id = DEV_ID,
        timestamp = pubtime
    }}
    local jsonCln = string.sub(json.encode(pubData), 2, -2)
    if g_mq:isconnected() == true then
        local pub_sta = g_mq:publish(PUB_NOR_TP, jsonCln, 0, 0)
        if pub_sta ~= true then
            UpBUP(jsonCln, pubtime, B_EP_BADR, B_E)
        else
            PLog("publish, parameter log...", 3)
        end
    else
        UpBUP(jsonCln, pubtime, B_EP_BADR, B_E)
    end
    PLog(jsonCln, 4)
end
function PubSta(Alm, staID, staV, staM, staMsg, pTm)
    pTm = pTm or os.time()
    local pubDat = {{
        data = {
            alarm = {{
                message = staMsg,
                value = tostring(toH32(staV)),
                mask = tostring(toH32(staM))
            }},
            params = staID
        },
        device_id = DEV_ID,
        timestamp = pTm,
        type = Alm and "STA_ALARM" or "STA_EVENT"
    }}
    local jsonCln = string.sub(json.encode(pubDat), 2, -2)
    if g_mq:isconnected() == true then
        local pub_sta = g_mq:publish(PUB_STA_TP, jsonCln, 0, 0)
        if pub_sta ~= true and Alm then
            UpBUP(jsonCln, pTm, B_SP_BADR, B_S)
        else
            PLog(Alm and "publish, status alarm..." or "publish, status even...", 3)
        end
    else
        if Alm then
            UpBUP(jsonCln, pTm, B_SP_BADR, B_S)
        end
    end
    PLog(jsonCln, 4)
end
function UpBUP(msg, pTm, badr, conf)
    local minTS = 4884916398 -- 2124/10/18
    local minTsIx, svIx
    for i = 1, conf.MAX_BUP do
        local rdTS = GAd(D.DW, badr, GBupL(i, conf.OFS_TMS, conf), 1) or 0
        local rdSzMsg = GAd(D.WR, badr, GBupL(i, conf.OFS_SZ_MSG, conf)) or 0
        if rdSzMsg < 60 or rdSzMsg > conf.SZ_MSG or rdTS == 0 or rdTS < conf.B_TS or rdTS > 4884916398 then
            svIx = i
            break
        else
            if rdTS > conf.B_TS or rdTS == 0 then
                if rdTS == 0 then
                    svIx = i
                    break
                end
                if i == 1 or rdTS < minTS then
                    minTS = rdTS
                    minTsIx = i
                end
            end
        end
    end
    svIx = svIx or minTsIx
    SAd(D.DW, pTm, badr, GBupL(svIx, conf.OFS_TMS, conf), 1)
    SAd(D.WR, #msg, badr, GBupL(svIx, conf.OFS_SZ_MSG, conf))
    SStrChk(msg, badr, GBupL(svIx, conf.OFS_MSG, conf))
end
function RePub(pubtp, badr, conf)
    local maxTS, maxTsIx, maxSzMsg, rdSzMsg, rdTS = 1730332800, 0, 0, 0, 0
    for i = 1, conf.MAX_BUP do
        rdSzMsg = GAd(D.WR, badr, GBupL(i, conf.OFS_SZ_MSG, conf)) or 0
        if rdSzMsg > 60 and rdSzMsg <= conf.SZ_MSG then
            rdTS = GAd(D.DW, badr, GBupL(i, conf.OFS_TMS, conf), 1) or 0
            if rdTS > conf.B_TS and rdTS < 4884916398 then
                if i == 1 or rdTS > maxTS then
                    maxTS = rdTS
                    maxTsIx = i
                    maxSzMsg = rdSzMsg
                end
            end
        end
    end
    if maxTsIx > 0 then
        local rdMsg = GStrChk(maxSzMsg, badr, GBupL(maxTsIx, conf.OFS_MSG, conf))
        if #rdMsg > 60 and #rdMsg <= conf.SZ_MSG then
            if g_mq:isconnected() then
                local pub_sta = g_mq:publish(pubtp, rdMsg, 0, 0)
                if pub_sta then
                    SAd(D.DW, 0, badr, GBupL(maxTsIx, conf.OFS_TMS, conf), 1)
                    SAd(D.WR, 0, badr, GBupL(maxTsIx, conf.OFS_SZ_MSG, conf))
                    PLog("republish...", 3)
                    PLog(rdMsg, 4)
                end
            end
        end
    end
end
function PubAlmLim(pars, limEvns, vals, maxs, mins, almTp)
    local pubDat = {{
        data = {
            events = limEvns,
            params = pars,
            max = maxs,
            min = mins,
            values = vals
        },
        device_id = DEV_ID,
        timestamp = os.time(),
        type = almTp
    }}
    local jsonCln = string.sub(json.encode(pubDat), 2, -2)
    PLog("publish, parameter alarm...", 3)
    PLog(jsonCln, 4)
    return g_mq:publish(PUB_ALM_TP, jsonCln, 0, 0)
end
function ChkLim(parIx, cv)
    local limHVal = GAd(D.FT, LIM_HVAL_BADR, parIx)
    local limLVal = GAd(D.FT, LIM_LVAL_BADR, parIx)
    local limEvn
    if limHVal <= limLVal then
        limEvn = "N"
    elseif (limHVal == 0 and limHVal == 0) then
        limEvn = "N"
    else
        limEvn = (cv > limHVal and "O") or (cv < limLVal and "U") or "N"
    end
    return limEvn, limHVal, limLVal
end
function ChkRocLim(parIx, cv, pv)
    local rocLimH = GAd(D.FT, ROC_HVAL_BADR, parIx)
    local rocLimL = GAd(D.FT, ROC_LVAL_BADR, parIx)
    local rocLimE
    local rocVal = cv - pv
    if rocLimH <= rocLimL then
        rocLimE = "N"
    elseif (rocLimH <= 0 or rocLimL >= 0) then
        rocLimE = "N"
    else
        rocLimE = (rocVal > rocLimH and "O") or (rocVal < rocLimL and "U") or "N"
    end
    return rocVal, rocLimE, rocLimH, rocLimL
end
function ChkStaPar(Alm, pubtime)
    pubtime = pubtime or os.time()
    if #STA_ID > 0 and #STA_ADR > 0 then
        local adr, CmdId, Msg, lstCmdId
        local Isnm, Mask, Code
        for staIx = 1, #STA_ID do
            local staV = GAd(STA_TYP[staIx], STA_ADR[staIx])
            if staV ~= nil and staV == staV then
                for rowIx = 1, STA.MAX_ROW do
                    adr = addr_newnoaddr(STA_COD_BADR, GStaL(staIx, rowIx, STA.OFS_CID))
                    CmdId = addr_getstring(adr, STA.LEN_ID)
                    if CmdId ~= "" and CmdId ~= STA.EMP_MSG and CmdId ~= nil then
                        Code = GAd(D.WR, STA_COD_BADR, GStaL(staIx, rowIx, STA.OFS_CDE))
                        Mask = GAd(D.WR, STA_COD_BADR, GStaL(staIx, rowIx, STA.OFS_MSK))
                        if (staV & Mask) == Code then
                            Isnm = GAd(D.WR, STA_COD_BADR, GStaL(staIx, rowIx, STA.OFS_ISN))
                            adr = addr_newnoaddr(STA_COD_BADR, GStaL(staIx, rowIx, STA.OFS_MSG))
                            Msg = addr_getstring(adr, STA.LEN_MSG)
                            if Alm then
                                adr = addr_newnoaddr(STA_LST_BADR, staIx * STA.SZ_ID)
                                lstCmdId = addr_getstring(adr, STA.LEN_ID)
                                if (lstCmdId ~= nil) and (CmdId ~= lstCmdId) then
                                    PubSta(Alm, STA_ID[staIx], Code, Mask, Msg)
                                    adr = addr_newnoaddr(STA_LST_BADR, staIx * STA.SZ_ID)
                                    addr_setstring(adr, CmdId)
                                end
                            else
                                PubSta(Alm, STA_ID[staIx], Code, Mask, Msg, pubtime)
                            end
                            break
                        end
                    end
                end
            end
        end
    end
end
local function getExpnMts(num)
    local mts = 0
    local expn = 0
    if num == 0 then
        return 0, 0
    end
    while num < 1 do
        num = num * 2
        expn = expn - 1
    end
    while num >= 2 do
        num = num / 2
        expn = expn + 1
    end
    expn = expn + 127
    mts = (num - 1) * 2 ^ 23
    mts = math.floor(mts + 0.5)
    if expn <= 0 then
        expn = 0
        mts = 0
    end
    if expn >= 255 then
        expn = 255
        mts = 0
    end
    return expn, mts
end
function toH32(num)
    if num == nil or num ~= num then
        return "7fc00000"
    else
        local sign = num < 0 and 1 or 0
        local expn, mts = getExpnMts(math.abs(num))
        local bits = (sign * 2 ^ 31) + (expn * 2 ^ 23) + mts
        if bits == nil or bits ~= bits then
            return "7fc00000"
        else
            local hStr = string.format("%08X", math.tointeger(bits))
            return hStr
        end
    end
end
function frmH32(hex)
    if #hex == 8 and hex ~= nil and hex == hex then
        local inte = tonumber(hex, 16)
        local sign = ((inte >> 31) == 0) and 1 or -1
        local expn = ((inte >> 23) & 0xFF)
        local mts = inte & 0x7FFFFF
        if expn == 255 then
            return (mts == 0) and (sign * math.huge) or (0 / 0)
        end
        if expn > 0 then
            return sign * (1 + mts / 2 ^ 23) * 2 ^ (expn - 127)
        else
            return sign * (mts / 2 ^ 23) * 2 ^ (-126)
        end
    end
end
function findIx(arr, val)
    for i = 1, #arr do
        if arr[i] == val then
            return i
        end
    end
    return nil
end
function PLog(msg, pri)
    pri = pri or 0
    pri = 4
    if pri <= GAd(D.WR, PRINT_LOG_SET_ADR) % 10 and (pri > 0) then
        print("[" .. pri .. "] " .. os.date("%Y-%m-%d %H:%M:%S") .. " " .. msg)
    end
end
`

  const luaScriptMap = {
    'version1.0.0': luaScriptVersion100,
  }

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(luaScriptMap[luaScriptVersion])
      Swal.fire({
        icon: 'success',
        title: 'Copied!',
        text: 'Lua script copied to clipboard.',
        timer: 1500,
        showConfirmButton: false,
      })
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: 'Unable to copy the script.',
      })
    }
  }

  const luaOptions = [{value: 'version1.0.0', label: 'Version 1.0.0'}]

  const handleVersionChange = (selectedOption) => {
    setLuaScriptVersion(selectedOption.value)
  }

  return (
    <>
      {/* <SyntaxHighlighter language='lua' style={materialDark}>
        {luaScript}
      </SyntaxHighlighter> */}

      <h5 className='fw-bold mb-3'>Lua Script Generator</h5>

      <div className='d-flex align-items-center justify-content-between flex-wrap gap-3 mb-3'>
        <div style={{minWidth: 220, maxWidth: 300}}>
          <Select
            options={luaOptions}
            value={luaOptions.find((option) => option.value === luaScriptVersion)}
            onChange={handleVersionChange}
            isSearchable={false}
          />
        </div>
        <button className='btn btn-sm btn-primary' onClick={copyToClipboard}>
          Copy
        </button>
      </div>

      {/* <div
        style={{
          maxHeight: '60vh',
          overflowY: 'auto',
          background: '#2d2d2d',
          color: 'white',
          padding: '1rem',
          borderRadius: '8px',
        }}
      >
        <pre style={{whiteSpace: 'pre-wrap', margin: 0}}>{luaScriptMap[luaScriptVersion]}</pre>
      </div> */}

      <SyntaxHighlighter language='lua' style={materialDark} wrapLongLines>
        {luaScriptMap[luaScriptVersion]}
      </SyntaxHighlighter>
    </>
  )
}

export {VBoxShowScript}
